import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2926242a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-bubble" }
const _hoisted_2 = { class: "event-title" }
const _hoisted_3 = { class: "event-short-description" }
const _hoisted_4 = {
  key: 0,
  class: "event-full-description"
}
const _hoisted_5 = { class: "full-text" }
const _hoisted_6 = {
  key: 0,
  class: "event-notes"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Notes:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "connection-line" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-node" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timeline-event", { 
      'position-above': _ctx.position === 'above',
      'position-below': _ctx.position === 'below',
      'selected': _ctx.isSelected,
      'error-state': _ctx.hasError
    }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleHover(true))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleHover(false)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.event.title), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.event.shortDescription), 1),
      (_ctx.isSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_divider, { class: "my-2" }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.event.fullDescription), 1),
            (_ctx.event.notes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.event.notes), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8,
    _hoisted_9
  ], 34))
}